export default __webpack_public_path__ + "media/quote/reel-poster-39f8461b.png";